module.exports = __webpack_public_path__ + "static/img/life-style2.c9edf7ef.png";